import React, { FunctionComponent } from 'react';
import { SimpleHeaderLogo } from '../../atoms/simpleHeaderLogo';

type Props = {
  logoPc: string;
  logoSp: string;
};

export const Presentation: FunctionComponent<Props> = ({
  logoPc,
  logoSp
}) => {
  return (
    <div className="rtf-header-wrapper w-100">
      <SimpleHeaderLogo
        logoPc={logoPc}
        logoSp={logoSp}
        headerLogoClassName="header-logo"
      />
      <ul className="header-buttons-right hidden-xs">
        <li>
          <a className="inquiry" href="/contact">
            お問い合わせ
          </a>
        </li>
      </ul>
    </div>
  );
};
